<template>
  <base-card @close="close">
    <div id="form-creation-wrapper">
      <heading
        class="form-creation-heading"
        :heading="activeComponent.heading()"
      />
      <Component
        :is="activeComponent.component"
        :form="subject"
        :inputIndex="inputIndex"
        :input="input"
        :field="field"
        :errors="errors"
        class="form-creation-component"
        @name-input="nameInput"
        @description-input="descriptionInput"
        @streaming-enabled-input="streamingEnabledInput"
        @field-title-input="fieldTitleInput"
        @field-duplicable-input="fieldDuplicableInput"
        @field-library-input="fieldLibraryInput"
        @input-created="inputCreated"
        @input-quantity-input="inputQuantityInput"
        @input-title-input="inputTitleInput"
        @input-type-input="inputTypeInput"
        @options-quantity-input="optionQuantityInput"
        @option-input="optionInput"
        @initialize-field="initializeField"
        @initialize-edit-field="initializeEditField"
        @delete-field="deleteField"
      />
      <div class="button-container">
        <Button
          class="scs-button"
          :text="activeComponent.buttons[0]"
          @click="activeComponent.back()"
          :processing="processing"
        /><Button
          class="scs-button"
          :text="activeComponent.buttons[1]"
          :processing="processing"
          @click="activeComponent.next()"
        />
      </div></div
  ></base-card>
</template>
<script>
import Button from "@/Components/UI/Button.vue";
import Heading from "@/Components/UI/Heading.vue";
import BaseCard from "@/Components/UI/FloatingCards/BaseFloatingCard.vue";
import NameAndDescription from "./NameAndDescription.vue";
import FieldInformation from "./FieldInformation.vue";
import InputInformation from "./InputInformation.vue";
import OptionsInput from "./OptionsInput.vue";
import FormView from "./FormView.vue";

export default {
  data() {
    return {
      activeComponent: undefined,
      errors: {
        name: false,
        field: {
          name: false,
          inputQuantity: false,
        },
        input: {
          title: false,
          optionQuantity: false,
        },
      },
      subject: {
        id: "form" + new Date().getTime(),
        name: undefined,
        description: undefined,
        streamingEnabled: false,
        streamingURI: undefined,
        fields: [],
      },
      field: {
        name: undefined,
        inputQuantity: undefined,
        fields: [],
        duplicable: false,
        libraryEnabled: false,
      },
      input: {
        inputTitle: undefined,
        inputType: undefined,
        placeholder: undefined,
      },
      inputIndex: 0,
      fieldEditIndex: undefined,
    };
  },
  computed: {
    components() {
      return {
        NameAndDescription: {
          component: "NameAndDescription",
          heading: () => {
            return "Name and Description";
          },
          buttons: ["Close", "Next"],
          next: () => {
            if (!this.subject.name) {
              this.errors.name = true;
              return;
            } else {
              this.errors.name = false;
              if (this.subject.fields.length > 0) {
                this.navigate("FormView");
              } else {
                this.navigate("FieldInformation");
              }
            }
          },
          back: () => {
            if (this.subject.fields.length > 0) {
              this.navigate("FormView");
            } else {
              this.close();
            }
          },
        },
        FieldInformation: {
          component: "FieldInformation",
          heading: () => {
            return "Field Details";
          },
          buttons: ["Back", "Next"],
          next: () => {
            if (!this.field.name) {
              this.errors.field.name = true;
              return;
            } else {
              this.errors.field.name = false;
              if (this.field.libraryEnabled) {
                this.navigate("FormView");
                this.addField(this.fieldEditIndex);
              } else {
                if (this.field.inputQuantity === undefined) {
                  this.errors.field.inputQuantity = true;
                  return;
                } else {
                  this.errors.field.inputQuantity = false;
                  this.navigate("InputInformation");
                }
              }
            }
          },
          back: () => {
            this.navigate("NameAndDescription");
            this.resetField();
          },
        },
        InputInformation: {
          component: "InputInformation",
          heading: () => {
            return `Input ${this.inputIndex + 1} of ${
              this.field.inputQuantity
            }`;
          },
          buttons: ["Back", "Next"],
          next: () => {
            if (!this.input.inputTitle) {
              this.errors.input.title = true;
              return;
            } else {
              this.errors.input.title = false;
            }
            if (this.input.inputType === "select") {
              if (!this.input.optionQuantity) {
                this.errors.input.optionQuantity = true;
                return;
              } else {
                this.errors.input.optionQuantity = false;
                this.navigate("OptionsInput");
                return;
              }
            }
            this.addInput();
            if (this.inputIndex === this.field.inputQuantity - 1) {
              this.addField(this.fieldEditIndex);
              this.navigate("FormView");
            } else {
              this.inputIndex++;
              this.navigate("InputInformation");
            }
          },
          back: () => {
            if (this.inputIndex === 0) {
              this.navigate("FieldInformation");
              this.resetInput();
              this.inputIndex = undefined;
            } else {
              this.inputIndex--;
              this.input = this.field.fields[this.inputIndex];
            }
          },
        },
        OptionsInput: {
          component: "OptionsInput",
          heading: () => {
            return "Options";
          },
          buttons: ["Back", "Next"],
          next: () => {
            this.addInput();
            if (this.inputIndex === this.field.inputQuantity - 1) {
              this.addField(this.fieldEditIndex);
              this.navigate("FormView");
            } else {
              this.inputIndex++;
              this.navigate("InputInformation");
            }
          },
          back: () => {
            this.navigate("InputInformation");
            this.input.options = [];
          },
        },
        FormView: {
          component: "FormView",
          heading: () => {
            return "Review";
          },
          buttons: ["Back", "Save"],
          next: () => {
            this.addForm();
          },
          back: () => {
            this.resetField();
            this.resetInput();
            this.navigate("NameAndDescription");
          },
        },
      };
    },
  },
  methods: {
    navigate(component) {
      this.activeComponent = this.components[component];
    },
    close() {
      this.$emit("close");
    },
    async addForm() {
      this.$emit("add-form", this.subject);
    },
    resetInput() {
      this.input = {
        inputTitle: undefined,
        inputType: undefined,
        placeholder: undefined,
      };
    },
    resetField() {
      this.field = {
        name: undefined,
        inputQuantity: undefined,
        fields: [],
        duplicable: false,
        libraryEnabled: false,
      };
    },
    addField(index) {
      if (index !== undefined) {
        this.subject.fields[index] = { ...this.field };
      } else {
        this.subject.fields.push({ ...this.field });
      }
      this.resetField();
      this.resetInput();
    },
    addInput() {
      this.field.fields[this.inputIndex] = { ...this.input };
      this.fieldEditIndex = undefined;
      this.resetInput();
    },
    nameInput(value) {
      this.subject.name = value;
    },
    descriptionInput(value) {
      this.subject.description = value;
    },
    streamingEnabledInput(value) {
      console.log(value);
      this.subject.streamingEnabled = value;
    },
    fieldTitleInput(value) {
      this.field.name = value;
    },
    fieldDuplicableInput(value) {
      this.field.duplicable = value;
    },
    fieldLibraryInput(value) {
      this.field.libraryEnabled = value;
      if (value === true) {
        this.field.fields = [
          {
            inputTitle: "Song Name",
            inputType: "text",
            placeholder: "Song Name",
          },
          {
            inputTitle: "Song Artist",
            inputType: "text",
            placeholder: "Song Artist",
          },
          {
            inputTitle: "Notes",
            inputType: "text",
            placeholder: "Notes",
          },
        ];
      } else {
        this.field.fields = [];
      }
    },
    inputQuantityInput(int) {
      this.field.inputQuantity = int;
    },
    inputTitleInput(value) {
      this.input.inputTitle = value;
    },
    inputTypeInput(value) {
      this.input.inputType = value;
    },
    optionQuantityInput(int) {
      this.input.optionQuantity = int;
    },
    optionInput({ value, index }) {
      if (!this.input.options) {
        this.input.options = [];
      }
      this.input.options[index] = value;
    },
    deleteField(index) {
      this.subject.fields.splice(index, 1);
    },
    // todo : drag and drop rearrange fields
    initializeField() {
      this.resetInput();
      this.resetField();
      this.inputindex = 0;
      this.navigate("FieldInformation");
    },
    initializeEditField({ field, index }) {
      this.field = { ...field };
      this.fieldEditIndex = index;
      this.navigate("FieldInformation");
    },
  },
  components: {
    BaseCard,
    Button,
    Heading,
    NameAndDescription,
    OptionsInput,
    FieldInformation,
    InputInformation,
    FormView,
  },
  created() {
    this.navigate("NameAndDescription");
    if (this.form) {
      this.subject = { ...this.form };
    }
  },
  props: ["form", "mode", "processing"],
  emits: ["close", "add-form"],
};
</script>
<style scoped>
@media screen {
  .button-container {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }
  #form-creation-wrapper {
    width: 100%;
    box-sizing: border-box;
  }
  .form-creation-heading {
    position: sticky;
    top: 0;
    /* background-color: white; */
  }

  .scs-button {
    margin: 5px;
  }

  .form-creation-component {
    /* max-height: 50vh; */
    overflow: scroll;
  }
  @media (min-width: 800px) {
    #form-creation-wrapper {
      width: fit-content;
    }
  }
}
</style>
